export const findLlmConfig = (name, options) =>
  options.find(option => option.name === name);

// Previous value clamped into the supported range, or its midpoint when there is none.
export const clampTemperature = (value, { min, max }) => {
  const number = Number(value);
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    Number.isNaN(number)
  ) {
    return Number(((min + max) / 2).toFixed(1));
  }
  return Math.min(max, Math.max(min, number));
};

// Deprecated configs already resolve to their replacement at runtime and are
// rejected on save, so the form edits the effective config instead.
export const initialSlotConfig = (storedSlot, options) => {
  const slot = storedSlot ?? {};
  const stored = findLlmConfig(slot.llm_config, options);
  if (!stored?.deprecated) {
    return {
      llm_config: slot.llm_config ?? '',
      temperature: slot.temperature ?? null,
    };
  }
  const replacement = findLlmConfig(stored.replacement, options);
  return {
    llm_config: replacement.name,
    temperature: replacement.temperature
      ? clampTemperature(slot.temperature, replacement.temperature)
      : null,
  };
};

export const slotConfigPayload = ({ llm_config: llmConfig, temperature }) => {
  const payload = { llm_config: llmConfig };
  if (temperature !== null && temperature !== '') {
    payload.temperature = Number(temperature);
  }
  return payload;
};
